import type { ComponentProps } from "react";

import { MoreDetailsButton, ServiceCardTemplate } from "./card-template";
import { SERVICE_IMAGE_BLOCK_CLASS_NAME } from "./common";

import type { ServiceEntity } from "~/entities/service";
import { createImageUrl } from "~/entities/service";
import { ServiceDetailsDialog, ServiceImageBlock } from "~/features/service";
import { useConfig } from "~/shared/config";
import { createUrl } from "~/shared/http";
import { cn } from "~/shared/ui";
import type { Card } from "~/shared/ui/card";

type Props = ComponentProps<typeof Card> & {
  service: ServiceEntity.Schema;
};

function ServiceCard({ service, ...props }: Props) {
  const {
    backendApp: { protocol, address, port, apiBaseUrl },
  } = useConfig();

  return (
    <ServiceCardTemplate
      service={{
        ...service,
        image: (
          <ServiceImageBlock
            imageProps={{
              src: createImageUrl(
                createUrl({
                  protocol,
                  address,
                  port,
                  baseUrl: apiBaseUrl,
                }),
                service.imageId,
              ),
            }}
            className={cn(SERVICE_IMAGE_BLOCK_CLASS_NAME)}
            skeletonProps={{
              className: "rounded-b-none",
            }}
          />
        ),
      }}
      button={
        <ServiceDetailsDialog
          service={service}
          triggerProps={{
            asChild: true,
            children: <MoreDetailsButton />,
          }}
        />
      }
      {...props}
    />
  );
}

export { ServiceCard };
